import React, { useEffect, useState } from "react";
import Tutorial from "../Tutorial/tutorial";
import Agree from "../Agree/agree";
import { Anal } from "../Anal/anal";

export const Camera = ({ title = "" }: { title?: string }) => {
  const [isVideoReady, setIsVideoReady] = useState(false);
  const [isAgree, setIsAgree] = useState(false);

  if (!isAgree) {
    return <Agree setIsAgree={setIsAgree} title={title} />;
  }

  return (
    <>
      <Anal setIsVideoReady={setIsVideoReady} />
      {!isVideoReady && <Tutorial />}
    </>
  );
};
